import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewChild } from "@angular/core";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { LookupService } from "projects/sepidz-web-framework/src/lib/services";
import { of } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ElementFormula } from "../../../models/base-info/element-formula.model";
import { Element } from "../../../models/base-info/element.model";
import { FormulaInfo } from "../../../models/base-info/formula.model";
import { ElementGroup } from "../../../models/enums/element-group";
import { ElementKind } from "../../../models/enums/element-kind";

@Component({
  selector: "ngx-element-formula",
  templateUrl: "./element-formula.component.html",
  styleUrls: ["./element-formula.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElementFormulaComponent extends BaseFormComponent<ElementFormula> {
  @Input() _columns: form_control[] = [];
  @ViewChild("elementFormula") public elementFormula: KGridComponent;
  currentSeletedColumnKey: string = "Formula";
  rows = 4;
  cols = 73;
  ElementIsLoading: boolean;
  public apiName: string = "Element";
  public label: string = "تعریف فرمول عامل";
  formulaInfo: FormulaInfo[];
  PropertyInfo: FormulaInfo[] = [];
  elements: Element[];
  ActiveAdjustmentElemenet: Element[];
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, private lookupservice: LookupService) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.PropertyInfo = [];
    this.setColumns();
    this.setFormulaInfo();
  }
  async setColumns() {
    this.columns = [];
    this.columns.push(<form_control>{
      label: "عبارت شرطی",
      controlType: FormControlTypes.textbox,
      modelName: "Condition",
      disabled: false,
      name: "Condition",
      order: 0,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.columns.push(<form_control>{
      label: "عبارت محاسباتی",
      controlType: FormControlTypes.textbox,
      modelName: "Formula",
      disabled: false,
      name: "Formula",
      order: 1,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: true,
    });

    this.orignalColumns = this.columns;
    this.setFormGroup(this.model);
    this.setValue("formulaInfo", undefined);
  }
  _filterFormula: ElementFormula[];
  get filterFormula(): ElementFormula[] {
    if (!this._filterFormula || this._filterFormula.length <= 0)
      this._filterFormula = this.currentrow?.ElementFormulas?.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached);
    return this._filterFormula;
  }
  set filterFormula(value: ElementFormula[]) {
    value.forEach((x) => {
      if (
        !this.currentrow.ElementFormulas.some(
          (s) => (s.Id && s.Id !== 0 && s.Id === x.Id) || (x.TempRowNumber && s.TempRowNumber === x.TempRowNumber)
        )
      )
        this.currentrow.ElementFormulas.push(x);
    });
    this._filterFormula = this.currentrow?.ElementFormulas?.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached);
  }
  setFormulaInfo() {
    this.formulaInfo = [];
    if (this.elements && this.elements.length > 0) {
      this.formulaInfo.push(this.getpersonelInfo());
      this.formulaInfo.push(this.getElement());
      this.formulaInfo.push(this.getTaxTable());
      this.formulaInfo.push(this.getCurrentMontBackpay());
    } else {
      this.httpCommonService
        .getList("Element")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (data) => {
            this.elements = data as [];
            this.formulaInfo.push(this.getpersonelInfo());
            this.formulaInfo.push(this.getElement());
            this.formulaInfo.push(this.getTaxTable());
            this.formulaInfo.push(this.getCurrentMontBackpay());
          },
          (error) => this.getFailedHelper(error)
        );
    }
  }
  getElement() {
    const element: FormulaInfo = <FormulaInfo>{};
    element.Title = "عوامل";
    element.key = "element";
    element.items = [];

    element.items.push(this.getEmploymentOrderElement());
    element.items.push(this.getComputationalElement());
    element.items.push(this.getPrevMonthComputationalElement());
    element.items.push(this.getPrevYearMonthComputationalElement());
    element.items.push(this.getMonthlyInputElement());
    element.items.push(this.getLoanElement());
    element.items.push(this.getSystemsInfo());
    element.items.push(this.getPersonnelElementInitial());

    return element;
  }
  getTaxTable() {
    const TaxTable: FormulaInfo = <FormulaInfo>{};
    TaxTable.Title = "خروجی جدول";
    TaxTable.key = "TaxTable";
    TaxTable.items = [];

    const Bonus: FormulaInfo = <FormulaInfo>{};
    TaxTable.items.push(Bonus);
    Bonus.Title = "مزایا-خروجی جدول";
    Bonus.key = "TT";
    Bonus.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Bonus)
        .forEach((x) => {
          this.getNode(x as Element, Bonus, "");
        });
    }
    const Deduct: FormulaInfo = <FormulaInfo>{};
    TaxTable.items.push(Deduct);
    Deduct.Title = "کسور-خروجی جدول";
    Deduct.key = "TT";
    Deduct.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Deduct)
        .forEach((x) => {
          this.getNode(x as Element, Deduct, "");
        });
    }
    const Boss: FormulaInfo = <FormulaInfo>{};
    TaxTable.items.push(Boss);
    Boss.Title = "تعهدات-خروجی جدول";
    Boss.key = "TT";
    Boss.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Boss)
        .forEach((x) => {
          this.getNode(x as Element, Boss, "");
        });
    }
    const Others: FormulaInfo = <FormulaInfo>{};
    TaxTable.items.push(Others);
    Others.Title = "سایر-خروجی جدول";
    Others.key = "TT";
    Others.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Other)
        .forEach((x) => {
          this.getNode(x as Element, Others, "");
        });
    }
    const RewardPaymentBonus: FormulaInfo = <FormulaInfo>{};
    TaxTable.items.push(RewardPaymentBonus);
    RewardPaymentBonus.Title = "هزینه عیدی-مالیات کل";
    RewardPaymentBonus.key = "RPTT";
    RewardPaymentBonus.items = [];
    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.RwrdPay)
        .forEach((x) => {
          this.getNode(x as Element, RewardPaymentBonus, "");
        });
    }
    const VacationPaymentBonus: FormulaInfo = <FormulaInfo>{};
    TaxTable.items.push(VacationPaymentBonus);
    VacationPaymentBonus.Title = "بازخرید مرخصی-مالیات کل";
    VacationPaymentBonus.key = "VPTT";
    VacationPaymentBonus.items = [];
    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.VacationBuy)
        .forEach((x) => {
          this.getNode(x as Element, VacationPaymentBonus, "");
        });
    }
    return TaxTable;
  }
  getCurrentMontBackpay() {
    const CurrentMontBackpay: FormulaInfo = <FormulaInfo>{};
    CurrentMontBackpay.Title = "معوقه های ماه جاری";
    CurrentMontBackpay.key = "CurrentMontBackpay";
    CurrentMontBackpay.items = [];

    const Bonus: FormulaInfo = <FormulaInfo>{};
    CurrentMontBackpay.items.push(Bonus);
    Bonus.Title = "مزایا-معوقه های ماه جاری";
    Bonus.key = "BMV";
    Bonus.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Bonus)
        .forEach((x) => {
          this.getNode(x as Element, Bonus, "");
        });
    }
    const Deduct: FormulaInfo = <FormulaInfo>{};
    CurrentMontBackpay.items.push(Deduct);
    Deduct.Title = "کسور-معوقه های ماه جاری";
    Deduct.key = "BMV";
    Deduct.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Deduct)
        .forEach((x) => {
          this.getNode(x as Element, Deduct, "");
        });
    }
    const Boss: FormulaInfo = <FormulaInfo>{};
    CurrentMontBackpay.items.push(Boss);
    Boss.Title = "تعهدات-معوقه های ماه جاری";
    Boss.key = "BMV";
    Boss.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Boss)
        .forEach((x) => {
          this.getNode(x as Element, Boss, "");
        });
    }
    const Others: FormulaInfo = <FormulaInfo>{};
    CurrentMontBackpay.items.push(Others);
    Others.Title = "سایر-معوقه های ماه جاری";
    Others.key = "BMV";
    Others.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Other)
        .forEach((x) => {
          this.getNode(x as Element, Others, "");
        });
    }
    return CurrentMontBackpay;
  }
  getEmploymentOrderElement() {
    const EmploymentOrder: FormulaInfo = <FormulaInfo>{};
    EmploymentOrder.Title = "حکمی";
    EmploymentOrder.key = "EmploymentOrder";
    EmploymentOrder.items = [];

    const Bonus: FormulaInfo = <FormulaInfo>{};
    EmploymentOrder.items.push(Bonus);
    Bonus.Title = "مزایا";
    Bonus.key = "Bonus";
    Bonus.items = [];
    const EMP: FormulaInfo = <FormulaInfo>{};
    Bonus.items.push(EMP);
    EMP.Title = "حکم معادل";
    EMP.key = "EMP";
    EMP.items = [];
    const FMEMP: FormulaInfo = <FormulaInfo>{};
    Bonus.items.push(FMEMP);
    FMEMP.Title = "اولین حکم ماه";
    FMEMP.key = "FMEMP";
    FMEMP.items = [];
    const LMEMP: FormulaInfo = <FormulaInfo>{};
    Bonus.items.push(LMEMP);
    LMEMP.Title = "آخرین حکم ماه";
    LMEMP.key = "LMEMP";
    LMEMP.items = [];
    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Bonus && x.ElementKindCode === ElementKind.EmploymentOrder)
        .forEach((x) => {
          this.getNode(x as Element, EMP, "");
          this.getNode(x as Element, FMEMP, "");
          this.getNode(x as Element, LMEMP, "");
        });
    }
    const Deduct: FormulaInfo = <FormulaInfo>{};
    EmploymentOrder.items.push(Deduct);
    Deduct.Title = "کسور";
    Deduct.key = "Deduct";
    Deduct.items = [];
    const DEMP: FormulaInfo = <FormulaInfo>{};
    Deduct.items.push(DEMP);
    DEMP.Title = "حکم معادل";
    DEMP.key = "EMP";
    DEMP.items = [];
    const FMDEMP: FormulaInfo = <FormulaInfo>{};
    Deduct.items.push(FMDEMP);
    FMDEMP.Title = "اولین حکم ماه";
    FMDEMP.key = "FMEMP";
    FMDEMP.items = [];
    const LMDEMP: FormulaInfo = <FormulaInfo>{};
    Deduct.items.push(LMDEMP);
    LMDEMP.Title = "آخرین حکم ماه";
    LMDEMP.key = "LMEMP";
    LMDEMP.items = [];
    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Deduct && x.ElementKindCode === ElementKind.EmploymentOrder)
        .forEach((x) => {
          this.getNode(x as Element, DEMP, "");
          this.getNode(x as Element, FMDEMP, "");
          this.getNode(x as Element, LMDEMP, "");
        });
    }

    const Boss: FormulaInfo = <FormulaInfo>{};
    EmploymentOrder.items.push(Boss);
    Boss.Title = "تعهدات";
    Boss.key = "Boss";
    Boss.items = [];
    const BEMP: FormulaInfo = <FormulaInfo>{};
    Boss.items.push(BEMP);
    BEMP.Title = "حکم معادل";
    BEMP.key = "EMP";
    BEMP.items = [];
    const FMBEMP: FormulaInfo = <FormulaInfo>{};
    Boss.items.push(FMBEMP);
    FMBEMP.Title = "اولین حکم ماه";
    FMBEMP.key = "FMEMP";
    FMBEMP.items = [];
    const LMBEMP: FormulaInfo = <FormulaInfo>{};
    Boss.items.push(LMBEMP);
    LMBEMP.Title = "آخرین حکم ماه";
    LMBEMP.key = "LMEMP";
    LMBEMP.items = [];
    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Boss && x.ElementKindCode === ElementKind.EmploymentOrder)
        .forEach((x) => {
          this.getNode(x as Element, BEMP, "");
          this.getNode(x as Element, FMBEMP, "");
          this.getNode(x as Element, LMBEMP, "");
        });
    }
    const Works: FormulaInfo = <FormulaInfo>{};
    EmploymentOrder.items.push(Works);
    Works.Title = "کارکرد";
    Works.key = "Works";
    Works.items = [];
    const WEMP: FormulaInfo = <FormulaInfo>{};
    Works.items.push(WEMP);
    WEMP.Title = "حکم معادل";
    WEMP.key = "EMP";
    WEMP.items = [];
    const FMWEMP: FormulaInfo = <FormulaInfo>{};
    Works.items.push(FMWEMP);
    FMWEMP.Title = "اولین حکم ماه";
    FMWEMP.key = "FMEMP";
    FMWEMP.items = [];
    const LMWEMP: FormulaInfo = <FormulaInfo>{};
    Works.items.push(LMWEMP);
    LMWEMP.Title = "آخرین حکم ماه";
    LMWEMP.key = "LMEMP";
    LMWEMP.items = [];
    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Work && x.ElementKindCode === ElementKind.EmploymentOrder)
        .forEach((x) => {
          this.getNode(x as Element, WEMP, "");
          this.getNode(x as Element, FMWEMP, "");
          this.getNode(x as Element, LMWEMP, "");
        });
    }
    const Others: FormulaInfo = <FormulaInfo>{};
    EmploymentOrder.items.push(Others);
    Others.Title = "سایر";
    Others.key = "Others";
    Others.items = [];
    const OEMP: FormulaInfo = <FormulaInfo>{};
    Others.items.push(OEMP);
    OEMP.Title = "حکم معادل";
    OEMP.key = "EMP";
    OEMP.items = [];
    const FMOEMP: FormulaInfo = <FormulaInfo>{};
    Others.items.push(FMOEMP);
    FMOEMP.Title = "اولین حکم ماه";
    FMOEMP.key = "FMEMP";
    FMOEMP.items = [];
    const LMOEMP: FormulaInfo = <FormulaInfo>{};
    Others.items.push(LMWEMP);
    LMOEMP.Title = "آخرین حکم ماه";
    LMOEMP.key = "LMEMP";
    LMOEMP.items = [];
    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Other && x.ElementKindCode === ElementKind.EmploymentOrder)
        .forEach((x) => {
          this.getNode(x as Element, OEMP, "");
          this.getNode(x as Element, FMOEMP, "");
          this.getNode(x as Element, LMOEMP, "");
        });
    }
    return EmploymentOrder;
  }
  getNode(Row: Element, Node: FormulaInfo, kind: string) {
    const p: FormulaInfo = <FormulaInfo>{};
    p.Title = "محاسباتی";
    p.key = Node.key + "_" + Row["Id"].toString();
    p.items = [];
    if (kind.includes("X")) p.Formula = "Tax_" + Node.key + "_" + Row["Id"].toString() + ",EYear,EMonth,TaxGroupRef)";
    else p.Formula = Node.key + "_" + Row["Id"].toString();
    p.Title = `${Node.Title}_${Row["Title"]}`;
    Node.items.push(p);
  }
  getPrevYearMonthComputationalElement() {
    const PreYearComputational: FormulaInfo = <FormulaInfo>{};
    PreYearComputational.Title = "محاسباتی سال تا ماه";
    PreYearComputational.key = "PreYearComputational";
    PreYearComputational.items = [];

    const Bonus: FormulaInfo = <FormulaInfo>{};
    PreYearComputational.items.push(Bonus);
    Bonus.Title = "مزایا-سال تا ماه";
    Bonus.key = "YMV";
    Bonus.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Bonus)
        .forEach((x) => {
          this.getNode(x as Element, Bonus, "");
        });
    }
    const Deduct: FormulaInfo = <FormulaInfo>{};
    PreYearComputational.items.push(Deduct);
    Deduct.Title = "کسور-سال تا ماه";
    Deduct.key = "YMV";
    Deduct.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Deduct)
        .forEach((x) => {
          this.getNode(x as Element, Deduct, "");
        });
    }
    const Boss: FormulaInfo = <FormulaInfo>{};
    PreYearComputational.items.push(Boss);
    Boss.Title = "تعهدات-سال تا ماه";
    Boss.key = "YMV";
    Boss.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Boss)
        .forEach((x) => {
          this.getNode(x as Element, Boss, "");
        });
    }
    const Others: FormulaInfo = <FormulaInfo>{};
    PreYearComputational.items.push(Others);
    Others.Title = "سایر-سال تا ماه";
    Others.key = "YMV";
    Others.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Other)
        .forEach((x) => {
          this.getNode(x as Element, Others, "");
        });
    }

    const EndYearBonus: FormulaInfo = <FormulaInfo>{};
    PreYearComputational.items.push(EndYearBonus);
    EndYearBonus.Title = "عيدي و پاداش آخر سال";
    EndYearBonus.key = "EndYearBonus";
    EndYearBonus.items = [];

    const RewardSaveBonus: FormulaInfo = <FormulaInfo>{};
    EndYearBonus.items.push(RewardSaveBonus);
    RewardSaveBonus.Title = "ذخیره عیدی";
    RewardSaveBonus.key = "RSYMV";
    RewardSaveBonus.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.RwrdSave)
        .forEach((x) => {
          this.getNode(x as Element, RewardSaveBonus, "");
        });
    }
    const RewardPaymentBonus: FormulaInfo = <FormulaInfo>{};
    EndYearBonus.items.push(RewardPaymentBonus);
    RewardPaymentBonus.Title = "هزینه عیدی";
    RewardPaymentBonus.key = "RPYMV";
    RewardPaymentBonus.items = [];
    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.RwrdPay)
        .forEach((x) => {
          this.getNode(x as Element, RewardPaymentBonus, "");
        });
    }

    const Buy: FormulaInfo = <FormulaInfo>{};
    PreYearComputational.items.push(Buy);
    Buy.Title = "ذخيره سنوات";
    Buy.key = "YBuy";
    Buy.items = [];
    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.EstablishmentTheReserveOfYearsOfService)
        .forEach((x) => {
          this.getNode(x as Element, Buy, "");
        });
    }
    const Vacation: FormulaInfo = <FormulaInfo>{};
    PreYearComputational.items.push(Vacation);
    Vacation.Title = "مرخصی";
    Vacation.key = "Vacation";
    Vacation.items = [];
    const VacationSaveBonus: FormulaInfo = <FormulaInfo>{};
    Vacation.items.push(VacationSaveBonus);
    VacationSaveBonus.Title = "ذخیره مرخصی";
    VacationSaveBonus.key = "VSYMV";
    VacationSaveBonus.items = [];
    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.VacationSave)
        .forEach((x) => {
          this.getNode(x as Element, Vacation, "");
        });
    }
    const VacationPaymentBonus: FormulaInfo = <FormulaInfo>{};
    Vacation.items.push(VacationPaymentBonus);
    VacationPaymentBonus.Title = "بازخرید مرخصی";
    VacationPaymentBonus.key = "VPYMV";
    VacationPaymentBonus.items = [];
    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.VacationBuy)
        .forEach((x) => {
          this.getNode(x as Element, VacationPaymentBonus, "");
        });
    }

    return PreYearComputational;
  }
  getPrevMonthComputationalElement() {
    const PreComputational: FormulaInfo = <FormulaInfo>{};
    PreComputational.Title = "محاسباتی ماه قبل";
    PreComputational.key = "PreComputational";
    PreComputational.items = [];

    const Bonus: FormulaInfo = <FormulaInfo>{};
    PreComputational.items.push(Bonus);
    Bonus.Title = "مزایا-محاسباتی ماه قبل";
    Bonus.key = "PMV";
    Bonus.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Bonus)
        .forEach((x) => {
          this.getNode(x as Element, Bonus, "");
        });
    }
    const Deduct: FormulaInfo = <FormulaInfo>{};
    PreComputational.items.push(Deduct);
    Deduct.Title = "کسور-محاسباتی ماه قبل";
    Deduct.key = "PMV";
    Deduct.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Deduct)
        .forEach((x) => {
          this.getNode(x as Element, Deduct, "");
        });
    }
    const Boss: FormulaInfo = <FormulaInfo>{};
    PreComputational.items.push(Boss);
    Boss.Title = "تعهدات-محاسباتی ماه قبل";
    Boss.key = "PMV";
    Boss.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Boss)
        .forEach((x) => {
          this.getNode(x as Element, Boss, "");
        });
    }
    const Others: FormulaInfo = <FormulaInfo>{};
    PreComputational.items.push(Others);
    Others.Title = "سایر-محاسباتی ماه قبل";
    Others.key = "PMV";
    Others.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Other)
        .forEach((x) => {
          this.getNode(x as Element, Others, "");
        });
    }

    const EndYearBonus: FormulaInfo = <FormulaInfo>{};
    PreComputational.items.push(EndYearBonus);
    EndYearBonus.Title = "عيدي و پاداش آخر سال";
    EndYearBonus.key = "EndYearBonus";
    EndYearBonus.items = [];

    const RewardSaveBonus: FormulaInfo = <FormulaInfo>{};
    EndYearBonus.items.push(RewardSaveBonus);
    RewardSaveBonus.Title = "ذخیره عیدی";
    RewardSaveBonus.key = "RSPMV";
    RewardSaveBonus.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.RwrdSave)
        .forEach((x) => {
          this.getNode(x as Element, RewardSaveBonus, "");
        });
    }
    const RewardPaymentBonus: FormulaInfo = <FormulaInfo>{};
    EndYearBonus.items.push(RewardPaymentBonus);
    RewardPaymentBonus.Title = "هزینه عیدی";
    RewardPaymentBonus.key = "RPPMV";
    RewardPaymentBonus.items = [];
    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.RwrdPay)
        .forEach((x) => {
          this.getNode(x as Element, RewardPaymentBonus, "");
        });
    }

    const Vacation: FormulaInfo = <FormulaInfo>{};
    PreComputational.items.push(Vacation);
    Vacation.Title = "مرخصی";
    Vacation.key = "Vacation";
    Vacation.items = [];
    const VacationSaveBonus: FormulaInfo = <FormulaInfo>{};
    Vacation.items.push(VacationSaveBonus);
    VacationSaveBonus.Title = "ذخیره مرخصی";
    VacationSaveBonus.key = "VSPMV";
    VacationSaveBonus.items = [];
    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.VacationSave)
        .forEach((x) => {
          this.getNode(x as Element, Vacation, "");
        });
    }
    const VacationPaymentBonus: FormulaInfo = <FormulaInfo>{};
    Vacation.items.push(VacationPaymentBonus);
    VacationPaymentBonus.Title = "بازخرید مرخصی";
    VacationPaymentBonus.key = "VPPMV";
    VacationPaymentBonus.items = [];
    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.VacationBuy)
        .forEach((x) => {
          this.getNode(x as Element, VacationPaymentBonus, "");
        });
    }

    const Buy: FormulaInfo = <FormulaInfo>{};
    PreComputational.items.push(Buy);
    Buy.Title = "ذخيره سنوات";
    Buy.key = "PBuy";
    Buy.items = [];
    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.EstablishmentTheReserveOfYearsOfService)
        .forEach((x) => {
          this.getNode(x as Element, Buy, "");
        });
    }
    return PreComputational;
  }
  getComputationalElement() {
    const Computational: FormulaInfo = <FormulaInfo>{};
    Computational.Title = "محاسباتی";
    Computational.key = "Computational";
    Computational.items = [];

    const Bonus: FormulaInfo = <FormulaInfo>{};
    Computational.items.push(Bonus);
    Bonus.Title = "مزایا";
    Bonus.key = "MV";
    Bonus.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Bonus)
        .forEach((x) => {
          this.getNode(x as Element, Bonus, "");
        });
    }

    const Deduct: FormulaInfo = <FormulaInfo>{};
    Computational.items.push(Deduct);
    Deduct.Title = "کسور";
    Deduct.key = "MV";
    Deduct.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Deduct)
        .forEach((x) => {
          this.getNode(x as Element, Deduct, "");
        });
    }
    const Boss: FormulaInfo = <FormulaInfo>{};
    Computational.items.push(Boss);
    Boss.Title = "تعهدات";
    Boss.key = "MV";
    Boss.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Boss)
        .forEach((x) => {
          this.getNode(x as Element, Boss, "");
        });
    }
    const Others: FormulaInfo = <FormulaInfo>{};
    Computational.items.push(Others);
    Others.Title = "سایر";
    Others.key = "MV";
    Others.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Other)
        .forEach((x) => {
          this.getNode(x as Element, Others, "");
        });
    }

    const EndYearBonus: FormulaInfo = <FormulaInfo>{};
    Computational.items.push(EndYearBonus);
    EndYearBonus.Title = "عيدي و پاداش آخر سال";
    EndYearBonus.key = "EndYearBonus";
    EndYearBonus.items = [];

    const RewardSaveBonus: FormulaInfo = <FormulaInfo>{};
    EndYearBonus.items.push(RewardSaveBonus);
    RewardSaveBonus.Title = "ذخیره عیدی";
    RewardSaveBonus.key = "RSMV";
    RewardSaveBonus.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.RwrdSave)
        .forEach((x) => {
          this.getNode(x as Element, RewardSaveBonus, "");
        });
    }
    const RewardPaymentBonus: FormulaInfo = <FormulaInfo>{};
    EndYearBonus.items.push(RewardPaymentBonus);
    RewardPaymentBonus.Title = "هزینه عیدی";
    RewardPaymentBonus.key = "RPMV";
    RewardPaymentBonus.items = [];
    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.RwrdPay)
        .forEach((x) => {
          this.getNode(x as Element, RewardPaymentBonus, "");
        });
    }

    const Vacation: FormulaInfo = <FormulaInfo>{};
    Computational.items.push(Vacation);
    Vacation.Title = "مرخصی";
    Vacation.key = "Vacation";
    Vacation.items = [];
    const VacationSaveBonus: FormulaInfo = <FormulaInfo>{};
    Vacation.items.push(VacationSaveBonus);
    VacationSaveBonus.Title = "ذخیره مرخصی";
    VacationSaveBonus.key = "VSMV";
    VacationSaveBonus.items = [];
    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.VacationSave)
        .forEach((x) => {
          this.getNode(x as Element, Vacation, "");
        });
    }
    const VacationPaymentBonus: FormulaInfo = <FormulaInfo>{};
    Vacation.items.push(VacationPaymentBonus);
    VacationPaymentBonus.Title = "بازخرید مرخصی";
    VacationPaymentBonus.key = "VPMV";
    VacationPaymentBonus.items = [];
    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.VacationBuy)
        .forEach((x) => {
          this.getNode(x as Element, VacationPaymentBonus, "");
        });
    }
    const Buy: FormulaInfo = <FormulaInfo>{};
    Computational.items.push(Buy);
    Buy.Title = "ذخيره سنوات";
    Buy.key = "Buy";
    Buy.items = [];
    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.EstablishmentTheReserveOfYearsOfService)
        .forEach((x) => {
          this.getNode(x as Element, Buy, "");
        });
    }
    return Computational;
  }
  getMonthlyInputElement() {
    const MonthlyInput: FormulaInfo = <FormulaInfo>{};
    MonthlyInput.Title = "ماهانه(فرم ورودی)";
    MonthlyInput.key = "MonthlyInput";
    MonthlyInput.items = [];

    const Bonus: FormulaInfo = <FormulaInfo>{};
    MonthlyInput.items.push(Bonus);
    Bonus.Title = "مزایا";
    Bonus.key = "MW";
    Bonus.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Bonus && x.ElementKindCode === ElementKind.InputForm)
        .forEach((x) => {
          this.getNode(x as Element, Bonus, "");
        });
    }
    const Work: FormulaInfo = <FormulaInfo>{};
    MonthlyInput.items.push(Work);
    Work.Title = "کارکرد";
    Work.key = "MW";
    Work.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Work && x.ElementKindCode === ElementKind.InputForm)
        .forEach((x) => {
          this.getNode(x as Element, Work, "");
        });
    }
    const Deduct: FormulaInfo = <FormulaInfo>{};
    MonthlyInput.items.push(Deduct);
    Deduct.Title = "کسور";
    Deduct.key = "MW";
    Deduct.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Deduct && x.ElementKindCode === ElementKind.InputForm)
        .forEach((x) => {
          this.getNode(x as Element, Deduct, "");
        });
    }
    const Boss: FormulaInfo = <FormulaInfo>{};
    MonthlyInput.items.push(Boss);
    Boss.Title = "تعهدات";
    Boss.key = "MW";
    Boss.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Boss && x.ElementKindCode === ElementKind.InputForm)
        .forEach((x) => {
          this.getNode(x as Element, Boss, "");
        });
    }
    const Others: FormulaInfo = <FormulaInfo>{};
    MonthlyInput.items.push(Others);
    Others.Title = "سایر";
    Others.key = "MW";
    Others.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Other && x.ElementKindCode === ElementKind.InputForm)
        .forEach((x) => {
          this.getNode(x as Element, Others, "");
        });
    }
    return MonthlyInput;
  }
  getLoanElement() {
    const Loan: FormulaInfo = <FormulaInfo>{};
    Loan.Title = "وام کارکنان";
    Loan.key = "Loan";
    Loan.items = [];

    const LoanInstallments: FormulaInfo = <FormulaInfo>{};
    Loan.items.push(LoanInstallments);
    LoanInstallments.Title = "قسط وام";
    LoanInstallments.key = "L";
    LoanInstallments.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Loan && x.ElementKindCode === ElementKind.Computational)
        .forEach((x) => {
          this.getNode(x as Element, LoanInstallments, "");
        });
    }
    const LoanPyed: FormulaInfo = <FormulaInfo>{};
    Loan.items.push(LoanPyed);
    LoanPyed.Title = "جمع اقساط پرداخت شده";
    LoanPyed.key = "LP";
    LoanPyed.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Loan && x.ElementKindCode === ElementKind.Computational)
        .forEach((x) => {
          this.getNode(x as Element, LoanPyed, "");
        });
    }
    const LoanOrignal: FormulaInfo = <FormulaInfo>{};
    Loan.items.push(LoanOrignal);
    LoanOrignal.Title = "اصل وام";
    LoanOrignal.key = "LO";
    LoanOrignal.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Loan && x.ElementKindCode === ElementKind.Computational)
        .forEach((x) => {
          this.getNode(x as Element, LoanOrignal, "");
        });
    }
    return Loan;
  }
  getEmployment() {
    const empKind: FormulaInfo = <FormulaInfo>{};
    empKind.Title = "استخدامی";
    empKind.key = "EmpKind";
    empKind.items = [];

    const StnWorkDays: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(StnWorkDays);
    StnWorkDays.Title = "کارکرد استاندارد سال";
    StnWorkDays.key = "StnWorkDays";
    StnWorkDays.Formula = "StnWorkDays";

    const YearDays: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(YearDays);
    YearDays.Title = "جمع روزهای سال تا بحال";
    YearDays.key = "YearDays";
    YearDays.Formula = "YearDays";

    const YearMonths: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(YearMonths);
    YearMonths.Title = "جمع ماه های سال تا بحال";
    YearMonths.key = "YearMonths";
    YearMonths.Formula = "YearMonths";

    const GroupCode: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(GroupCode);
    GroupCode.Title = "مقدار عددي گروه شغلي";
    GroupCode.key = "JobGroupCode";
    GroupCode.Formula = "JobGroupCode";

    const BaseCode: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(BaseCode);
    BaseCode.Title = "مقدار عددي پايه شغلي";
    BaseCode.key = "JobBaseCode";
    BaseCode.Formula = "JobBaseCode";

    const JobLevel_Code: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(JobLevel_Code);
    JobLevel_Code.Title = "مقدار عددي رتبه شغلي";
    JobLevel_Code.key = "JobRankingCode";
    JobLevel_Code.Formula = "JobRankingCode";

    const PersonnalCount: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(PersonnalCount);
    PersonnalCount.Title = "تعداد كل كاركنان";
    PersonnalCount.key = "PersonnalCount";
    PersonnalCount.Formula = "PersonnalCount";

    const CCPersonnalCount: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(CCPersonnalCount);
    CCPersonnalCount.Title = "تعداد كاركنان به تفكيك مركز هزينه";
    CCPersonnalCount.key = "CCPersonnalCount";
    CCPersonnalCount.Formula = "CCPersonnalCount";

    const LPersonnalCount: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(LPersonnalCount);
    LPersonnalCount.Title = "تعداد كاركنان به تفكيك محل خدمت";
    LPersonnalCount.key = "WrkPlacePersonnalCount";
    LPersonnalCount.Formula = "WrkPlacePersonnalCount";

    const OPersonnalCount: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(OPersonnalCount);
    OPersonnalCount.Title = "تعداد كاركنان به تفكيك واحد سازماني";
    OPersonnalCount.key = "OraganationPersonnalCount";
    OPersonnalCount.Formula = "OraganationPersonnalCount";

    const PPersonnalCount: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(PPersonnalCount);
    PPersonnalCount.Title = "تعداد كاركنان  به تفكيك پست";
    PPersonnalCount.key = "PositionPersonnalCount";
    PPersonnalCount.Formula = "PositionPersonnalCount";

    const EMPPersonnalCount: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(EMPPersonnalCount);
    EMPPersonnalCount.Title = "تعداد كاركنان به تفكيك استخدام";
    EMPPersonnalCount.key = "EmploymentPersonnalCount";
    EMPPersonnalCount.Formula = "EmploymentPersonnalCount";

    const WorkYears: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(WorkYears);
    WorkYears.Title = "سابقه كار درون سازماني به سال";
    WorkYears.key = "WorkYears";
    WorkYears.Formula = "WorkYears";

    const WorkMonths: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(WorkMonths);
    WorkMonths.Title = "سابقه كار درون سازماني به ماه";
    WorkMonths.key = "WorkMonths";
    WorkMonths.Formula = "WorkMonths";

    const AllWorkDays: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(AllWorkDays);
    AllWorkDays.Title = "سابقه كار درون سازماني به روز";
    AllWorkDays.key = "AllWorkDays";
    AllWorkDays.Formula = "AllWorkDays";

    const JobCode: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(JobCode);
    JobCode.Title = "كد شغل شخص";
    JobCode.key = "JobCode";
    JobCode.Formula = "JobCode";

    const PositionCode: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(PositionCode);
    PositionCode.Title = "كدپست شخص";
    PositionCode.key = "PositionCode";
    PositionCode.Formula = "PositionCode";

    const OrgCode: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(OrgCode);
    OrgCode.Title = "كد واحد سازماني شخص";
    OrgCode.key = "OrganizationnaCode";
    OrgCode.Formula = "OrganizationCode";

    const PersEMPKind: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(PersEMPKind);
    PersEMPKind.Title = "كد نوع استخدام شخص";
    PersEMPKind.key = "EmploymentKindCode";
    PersEMPKind.Formula = "EmploymentKindodeCode";

    const PersWorkplace: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(PersWorkplace);
    PersWorkplace.Title = "كد محل خدمت شخص";
    PersWorkplace.key = "PersWorkplaceCode";
    PersWorkplace.Formula = "PersWorkplaceCode";

    const PersCostCenter: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(PersCostCenter);
    PersCostCenter.Title = "كد مركز هزينه شخص";
    PersCostCenter.key = "PersCostCenter";
    PersCostCenter.Formula = "PersCostCenterCode";

    const BuyDelayWork: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(BuyDelayWork);
    BuyDelayWork.Title = "استقرار کسر خدمت";
    BuyDelayWork.key = "BuyDelayWork";
    BuyDelayWork.Formula = "BuyDelayWork";

    const BuyInitAmount: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(BuyInitAmount);
    BuyInitAmount.Title = "استقرار ذخیره سنوات";
    BuyInitAmount.key = "BuyInitAmount";
    BuyInitAmount.Formula = "BuyInitAmount";

    const CurWorkDays: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(CurWorkDays);
    CurWorkDays.Title = "كاركرد ماه جاري";
    CurWorkDays.key = "CurWorkDays";
    CurWorkDays.Formula = "CurWorkDays";

    const GrpAmount: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(GrpAmount);
    GrpAmount.Title = "مقدار مبلغي گروه شغلي";
    GrpAmount.key = "JobGroupAmount";
    GrpAmount.Formula = "JobGroupAmount";

    const BaseAmount: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(BaseAmount);
    BaseAmount.Title = "مقدار مبلغي پايه شغلي";
    BaseAmount.key = "JobBaseAmount";
    BaseAmount.Formula = "JobBaseAmount";

    const JobLevelAmount: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(JobLevelAmount);
    JobLevelAmount.Title = "مقدار مبلغي رتبه شغلي";
    JobLevelAmount.key = "JobRankingAmount";
    JobLevelAmount.Formula = "JobRankingAmount";

    return empKind;
  }
  getPersonnelElementInitial() {
    const PersonnelElementInitial: FormulaInfo = <FormulaInfo>{};
    PersonnelElementInitial.Title = "استقرار عوامل";
    PersonnelElementInitial.key = "PEI";
    PersonnelElementInitial.items = [];

    if (this.ActiveAdjustmentElemenet && this.ActiveAdjustmentElemenet.length > 0) {
      this.ActiveAdjustmentElemenet.forEach((x) => {
        this.getNode(x as Element, PersonnelElementInitial, "");
      });
    } else
      this.httpCommonService
        .getList(`Element/GetHrmActiveAdjustmentElemenet/${this.accountService.authService.getHrmPayCurentYearMonth().CurrentYearMonth}`)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (data) => {
            this.ActiveAdjustmentElemenet = data as [];
            this.ActiveAdjustmentElemenet.forEach((x) => {
              this.getNode(x as Element, PersonnelElementInitial, "");
            });
          },
          (error) => this.getFailedHelper(error)
        );

    return PersonnelElementInitial;
  }
  getpersonelInfo() {
    const personelInfo: FormulaInfo = <FormulaInfo>{};
    personelInfo.Title = "مشخصات کارکنان";
    personelInfo.key = "PersonelInfo";
    personelInfo.items = [];
    personelInfo.items.push(this.getIDCard());
    personelInfo.items.push(this.getEmployment());
    return personelInfo;
  }
  getSystemsInfo() {
    const systems: FormulaInfo = <FormulaInfo>{};
    systems.Title = "سیستمی";
    systems.key = "systems";
    systems.items = [];

    const monthDays: FormulaInfo = <FormulaInfo>{};
    monthDays.Title = "تعداد روزهای ماه";
    monthDays.key = "S_MonthDays";
    monthDays.Formula = "S_MonthDays";
    monthDays.items = [];
    systems.items.push(monthDays);

    const IssueYear: FormulaInfo = <FormulaInfo>{};
    IssueYear.Title = "سال جاری";
    IssueYear.key = "S_IssueYear";
    IssueYear.Formula = "S_IssueYear";
    IssueYear.items = [];
    systems.items.push(IssueYear);

    const IssueMonth: FormulaInfo = <FormulaInfo>{};
    IssueMonth.Title = "ماه جاری";
    IssueMonth.key = "S_IssueMonth";
    IssueMonth.Formula = "S_IssueMonth";
    IssueMonth.items = [];
    systems.items.push(IssueMonth);

    const EffectYear: FormulaInfo = <FormulaInfo>{};
    EffectYear.Title = "سال محاسبه";
    EffectYear.key = "S_EffectYear";
    EffectYear.Formula = "S_EffectYear";
    EffectYear.items = [];
    systems.items.push(EffectYear);

    const EffectMonth: FormulaInfo = <FormulaInfo>{};
    EffectMonth.Title = "ماه محاسبه";
    EffectMonth.key = "S_EffectMonth";
    EffectMonth.Formula = "S_EffectMonth";
    EffectMonth.items = [];
    systems.items.push(EffectMonth);

    const InsurableItems: FormulaInfo = <FormulaInfo>{};
    InsurableItems.Title = "جمع مزایای مشمول بیمه";
    InsurableItems.key = "S_InsurableItems";
    InsurableItems.Formula = "S_InsurableItems";
    InsurableItems.items = [];
    systems.items.push(InsurableItems);

    const TaxableContinues: FormulaInfo = <FormulaInfo>{};
    TaxableContinues.Title = "جمع مزایای مشمول مالیات مستمر";
    TaxableContinues.key = "S_TaxableContinues";
    TaxableContinues.Formula = "S_TaxableContinues";
    TaxableContinues.items = [];
    systems.items.push(TaxableContinues);

    const TaxableUnContinues: FormulaInfo = <FormulaInfo>{};
    TaxableUnContinues.Title = "جمع مشمول ماليات غير مستمر";
    TaxableUnContinues.key = "S_TaxableUnContinues";
    TaxableUnContinues.Formula = "S_TaxableUnContinues";
    TaxableUnContinues.items = [];
    systems.items.push(TaxableUnContinues);

    const BonusSum: FormulaInfo = <FormulaInfo>{};
    BonusSum.Title = "جمع مزایا";
    BonusSum.key = "S_BonusSum";
    BonusSum.Formula = "S_BonusSum";
    BonusSum.items = [];
    systems.items.push(BonusSum);

    const DeductSum: FormulaInfo = <FormulaInfo>{};
    DeductSum.Title = "جمع کسور";
    DeductSum.key = "S_DeductSum";
    DeductSum.Formula = "S_DeductSum";
    DeductSum.items = [];
    systems.items.push(DeductSum);

    const BossSum: FormulaInfo = <FormulaInfo>{};
    BossSum.Title = "جمع تعهدات";
    BossSum.key = "S_BossSum";
    BossSum.Formula = "S_BossSum";
    BossSum.items = [];
    systems.items.push(BossSum);

    const LoanPaymentSum: FormulaInfo = <FormulaInfo>{};
    LoanPaymentSum.Title = "جمع اقساط وام";
    LoanPaymentSum.key = "S_LoanPaymentSum";
    LoanPaymentSum.Formula = "S_LoanPaymentSum";
    LoanPaymentSum.items = [];
    systems.items.push(LoanPaymentSum);

    const MonthlyStandardWorks: FormulaInfo = <FormulaInfo>{};
    MonthlyStandardWorks.Title = "کارکرد استاندارد ماه";
    MonthlyStandardWorks.key = "S_MonthlyStandardWorks";
    MonthlyStandardWorks.Formula = "S_MonthlyStandardWorks";
    MonthlyStandardWorks.items = [];
    systems.items.push(MonthlyStandardWorks);

    const MonthlycalendardWorks: FormulaInfo = <FormulaInfo>{};
    MonthlycalendardWorks.Title = "کارکرد تقویمی ماه";
    MonthlycalendardWorks.key = "S_MonthlycalendardWorks";
    MonthlycalendardWorks.Formula = "S_MonthlycalendardWorks";
    MonthlycalendardWorks.items = [];
    systems.items.push(MonthlycalendardWorks);

    const MonthEffectWork: FormulaInfo = <FormulaInfo>{};
    MonthEffectWork.Title = "کارکرد موثر ماه";
    MonthEffectWork.key = "S_MonthEffectWork";
    MonthEffectWork.Formula = "S_MonthEffectWork";
    MonthEffectWork.items = [];
    systems.items.push(MonthEffectWork);

    const YearDaysCount: FormulaInfo = <FormulaInfo>{};
    YearDaysCount.Title = "تعداد روزهای سال";
    YearDaysCount.key = "S_YearDaysCount";
    YearDaysCount.Formula = "S_YearDaysCount";
    YearDaysCount.items = [];
    systems.items.push(YearDaysCount);

    const RewardEffectWork: FormulaInfo = <FormulaInfo>{};
    RewardEffectWork.Title = "کارکرد موثر عیدی پس از اصلاح";
    RewardEffectWork.key = "S_RewardEffectWork";
    RewardEffectWork.Formula = "S_RewardEffectWork";
    RewardEffectWork.items = [];
    systems.items.push(RewardEffectWork);

    const VacationBuyAmount: FormulaInfo = <FormulaInfo>{};
    VacationBuyAmount.Title = "مقدار باز خرید مرخصی";
    VacationBuyAmount.key = "S_VacationBuyAmount";
    VacationBuyAmount.Formula = "S_VacationBuyAmount";
    VacationBuyAmount.items = [];
    systems.items.push(VacationBuyAmount);

    const PersonnelCount: FormulaInfo = <FormulaInfo>{};
    PersonnelCount.Title = "تعداد نفر";
    PersonnelCount.key = "S_PersonnelCount";
    PersonnelCount.Formula = "S_PersonnelCount";
    PersonnelCount.items = [];
    systems.items.push(PersonnelCount);

    const BuyToutalDays: FormulaInfo = <FormulaInfo>{};
    BuyToutalDays.Title = "ایام ذخیره سنوات خدمت";
    BuyToutalDays.key = "S_BuyToutalDays";
    BuyToutalDays.Formula = "S_BuyToutalDays";
    BuyToutalDays.items = [];
    systems.items.push(BuyToutalDays);

    const IssueSickLeave: FormulaInfo = <FormulaInfo>{};
    IssueSickLeave.Title = "مرخصی استعلاجی حکمی";
    IssueSickLeave.key = "S_IssueSickLeave";
    IssueSickLeave.Formula = "S_IssueSickLeave";
    IssueSickLeave.items = [];
    systems.items.push(IssueSickLeave);

    const IssueUnpaidVacationDays: FormulaInfo = <FormulaInfo>{};
    IssueUnpaidVacationDays.Title = "مرخصی بدون حقوق حکمی";
    IssueUnpaidVacationDays.key = "S_IssueUnpaidVacationDays";
    IssueUnpaidVacationDays.Formula = "S_IssueUnpaidVacationDays";
    IssueUnpaidVacationDays.items = [];
    systems.items.push(IssueUnpaidVacationDays);

    return systems;
  }
  public hasChildren = (item: any) => item.items && item.items.length > 0;
  public fetchChildren = (item: any) => of(item.items);
  getIDCard() {
    const IDCard: FormulaInfo = <FormulaInfo>{};
    IDCard.Title = "شناسنامه ای";
    IDCard.key = "IDCard";
    IDCard.items = [];
    const Marage: FormulaInfo = <FormulaInfo>{};
    IDCard.items.push(Marage);
    Marage.Title = "وضعیت تاهل";
    Marage.key = "MrgStateKindCode";
    Marage.Formula = "MrgStateKindCode";

    const PersDateDIFFYear: FormulaInfo = <FormulaInfo>{};
    IDCard.items.push(PersDateDIFFYear);
    PersDateDIFFYear.Title = "سن شخص به سال";
    PersDateDIFFYear.key = "EmployeesAgeYear";
    PersDateDIFFYear.Formula = "EmployeesAgeYear";

    const PersDateDIFFMonth: FormulaInfo = <FormulaInfo>{};
    IDCard.items.push(PersDateDIFFMonth);
    PersDateDIFFMonth.Title = "سن شخص به ماه";
    PersDateDIFFMonth.key = "EmployeesAgeMonth";
    PersDateDIFFMonth.Formula = "EmployeesAgeMonth";

    const PersDateDIFFDay: FormulaInfo = <FormulaInfo>{};
    IDCard.items.push(PersDateDIFFDay);
    PersDateDIFFDay.Title = "سن شخص به روز";
    PersDateDIFFDay.key = "EmployeesAgeDay";
    PersDateDIFFDay.Formula = "EmployeesAgeDay";

    const SexualityCode: FormulaInfo = <FormulaInfo>{};
    IDCard.items.push(SexualityCode);
    SexualityCode.Title = "جنسیت شخص";
    SexualityCode.key = "SexualityCode";
    SexualityCode.Formula = "SexualityCode";

    const PersCode: FormulaInfo = <FormulaInfo>{};
    IDCard.items.push(PersCode);
    PersCode.Title = "کد پرسنلی";
    PersCode.key = "PersCode";
    PersCode.Formula = "PersCode";
    return IDCard;
  }
  onDeleteElementFormula($event: ElementFormula) {
    this.PropertyInfo = [];
    let temp = this.currentrow.ElementFormulas.find(
      (x) => (x.Id && x.Id !== 0 && x.Id === $event.Id) || ($event.TempRowNumber && x.TempRowNumber === $event.TempRowNumber)
    );
    if (temp && temp.State === RowState.New) temp.State = RowState.Detached;
    else temp.State = RowState.Delete;
    this._filterFormula = this.currentrow?.ElementFormulas?.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached);
    setTimeout(() => this.cd.markForCheck(), 200);
  }
  onSave() {
    let model: ElementFormula = this.getDataFromFormGroup();
    model.PropertyInfo = JSON.stringify(this.PropertyInfo);
    this.beforupdate();
    if (!this.isNewRow && model) {
      model.State = RowState.Modify;
      if (!this.currentrow.ElementFormulas) this.currentrow.ElementFormulas = [];
      this.currentrow.ElementFormulas.forEach((x) => {
        if ((x.Id && x.Id !== 0 && x.Id === model.Id) || (model.TempRowNumber && x.TempRowNumber === model.TempRowNumber)) {
          Object.assign(x, model);
          setTimeout(() => this.cd.markForCheck(), 400);
        }
      });
    } else if (this.isNewRow) {
      this.currentrow.ElementFormulas.push(model as ElementFormula);
      this.isNewRow = false;
    }
    this._filterFormula = this.currentrow?.ElementFormulas?.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached);
    this.elementFormula.refreshData();
    setTimeout(() => this.cd.markForCheck(), 400);
  }
  onEditElementFormula($event) {
    this.isNewRow = false;
    this.model = $event;
    if (this.model.PropertyInfo) this.PropertyInfo = JSON.parse(this.model.PropertyInfo);
    this.setFormGroup(this.model);
    if (this.model.State === RowState.NoChange) this.model.State = RowState.Modify;
    setTimeout(() => this.cd.markForCheck(), 400);
  }
  onCreateElementFormula($event: ElementFormula) {
    this.isNewRow = true;
    if (!this.currentrow.ElementFormulas) this.currentrow.ElementFormulas = [];
    this.model = <ElementFormula>{};
    this.model.ElementPropertyId = this.currentrow.Id ?? 0;
    this.model.TempRowNumber = this.currentrow.ElementFormulas.length + 100;
    this.model.State = RowState.New;
    this.setFormGroup(this.model);
    setTimeout(() => this.cd.markForCheck(), 400);
  }
  addControl() {
    this.setValue("PropertyInfo", this.model.PropertyInfo);
    this.setInputControlValue();
    setTimeout(() => this.cd.markForCheck(), 400);
  }
  private setInputControlValue() {
    if (this.formGroup && this.formGroup.controls["Formula"]) this.formGroup.controls["Formula"].setValue(this.replaceItemNames(this.model.Formula));
    if (this.formGroup && this.formGroup.controls["Condition"])
      this.formGroup.controls["Condition"].setValue(this.replaceItemNames(this.model.Condition));
  }
  beforupdate(): void {
    if (this.model && this.model.Formula) this.model.Formula = this.replaceItemValues(this.model.Formula);
    if (this.model && this.model.Condition) this.model.Condition = this.replaceItemValues(this.model.Condition);
  }
  private replaceItemValues(value: string): string {
    this.PropertyInfo.forEach((t) => {
      value = value.replace(this.wrap(t.Title), t.Formula);
    });
    return value;
  }

  private replaceItemNames(value: string): string {
    if (!value) {
      return;
    }
    this.PropertyInfo.forEach((t) => {
      value = value.replace(t.Formula, this.wrap(t.Title));
    });
    return value;
  }

  addItem(selected: any, cinput: HTMLTextAreaElement, finput: HTMLTextAreaElement) {
    if (selected && selected.dataItem) {
      if (selected.dataItem.items && selected.dataItem.items.lengh > 0) return;
      if (!this.PropertyInfo) this.PropertyInfo = [];
      const text = this.wrap(selected.dataItem.Title);
      if (!this.PropertyInfo.some((x) => x.key === selected.dataItem.key)) this.PropertyInfo.push(selected.dataItem);
      if (this.currentSeletedColumnKey === "Formula") {
        const value = finput.value;

        const start = finput.selectionStart;
        const end = finput.selectionEnd;

        finput.value = `${value.slice(0, start)}${text}${value.slice(end)}`;

        finput.selectionStart = finput.selectionEnd = start + text.length;
        this.formGroup.controls["Formula"].setValue(finput.value);
        finput.focus();
      } else {
        const value = cinput.value;

        const start = cinput.selectionStart;
        const end = cinput.selectionEnd;

        cinput.value = `${value.slice(0, start)}${text}${value.slice(end)}`;

        cinput.selectionStart = cinput.selectionEnd = start + text.length;
        this.formGroup.controls["Condition"].setValue(cinput.value);
        cinput.focus();
      }
    }
  }

  wrap(text) {
    return `[${text}]`;
  }
  onChange(key: string) {
    this.currentSeletedColumnKey = key;
  }
  async save() {
    this.selectorService.submitted$.next(this.submitted);
    this.result = this.currentrow;
    this.closeModal();
  }
}
